import { useTranslation } from "react-i18next";
import cn from "classnames";
import logoWordmark from "@/shared/assets/img/logo/ngo.svg";
import { BRAND_NAME } from "@/shared/config/brand";
import { getOrgLogo } from "@/shared/consts";
import type { RatingBadge } from "@/shared/types";

interface Props {
  isCollapsed: boolean;
  ratingBadge?: RatingBadge | null;
}

export default function SidebarLogo({ isCollapsed, ratingBadge }: Props) {
  const { t } = useTranslation("Sidebar");
  const { image, labelKey } = getOrgLogo(ratingBadge);
  const label = t(labelKey);

  return (
    <div className="relative flex items-center">
      <img
        src={image}
        className={cn(
          "object-contain transition-[opacity,width,height] duration-300",
          isCollapsed ? "h-7 w-7 opacity-100" : "h-0 w-0 opacity-0 absolute pointer-events-none",
        )}
        alt={isCollapsed ? label : ""}
        title={isCollapsed ? label : undefined}
        aria-hidden={!isCollapsed}
      />

      <div
        className={cn(
          "flex items-center gap-1 transition-[opacity] duration-300",
          isCollapsed ? "opacity-0 absolute pointer-events-none" : "opacity-100",
        )}
        aria-hidden={isCollapsed}>
        <img
          src={image}
          className={cn(
            "object-contain h-7 w-7 transition-[opacity] duration-300",
            isCollapsed ? "opacity-0" : "opacity-100",
          )}
          alt={isCollapsed ? "" : label}
          title={isCollapsed ? undefined : label}
        />
        <img
          src={logoWordmark}
          className={cn(
            "object-contain h-5 w-auto transition-[opacity] duration-300",
            isCollapsed ? "opacity-0" : "opacity-100",
          )}
          alt={isCollapsed ? "" : BRAND_NAME}
        />
      </div>
    </div>
  );
}
